import {useSyncExternalStore} from 'react'
import {AGENT_TASKS_MCP_PERMISSION_MODE_KEY} from '../utils/constants'
import {type McpPermissionMode, DEFAULT_MCP_PERMISSION_MODE} from '../types/api-task'

const VALID_MODES: readonly string[] = ['default', 'allow_all']

function isValidMcpPermissionMode(value: string | null): value is McpPermissionMode {
  return value !== null && VALID_MODES.includes(value)
}

function subscribe(callback: () => void) {
  const handleStorageChange = (e: StorageEvent) => {
    // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
    if (e.key === AGENT_TASKS_MCP_PERMISSION_MODE_KEY) {
      callback()
    }
  }
  window.addEventListener('storage', handleStorageChange)
  return () => window.removeEventListener('storage', handleStorageChange)
}

function getSnapshot(): McpPermissionMode {
  try {
    const stored = localStorage.getItem(AGENT_TASKS_MCP_PERMISSION_MODE_KEY)
    return isValidMcpPermissionMode(stored) ? stored : DEFAULT_MCP_PERMISSION_MODE
  } catch {
    return DEFAULT_MCP_PERMISSION_MODE
  }
}

function getServerSnapshot(): McpPermissionMode {
  return DEFAULT_MCP_PERMISSION_MODE
}

function setMcpPermissionMode(newValue: McpPermissionMode) {
  try {
    const oldValue = localStorage.getItem(AGENT_TASKS_MCP_PERMISSION_MODE_KEY)
    localStorage.setItem(AGENT_TASKS_MCP_PERMISSION_MODE_KEY, newValue)
    window.dispatchEvent(
      new StorageEvent('storage', {
        key: AGENT_TASKS_MCP_PERMISSION_MODE_KEY,
        newValue,
        oldValue,
      }),
    )
  } catch {
    // localStorage not available
  }
}

export function useLatestMcpPermissionMode(): [McpPermissionMode, (value: McpPermissionMode) => void] {
  const value = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)

  return [value, setMcpPermissionMode]
}
